import React, { Component } from "react";
import axios from "axios";

import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask } from "../../../Components/Items";
import { Tooltip, message, PageHeader, Tag } from "antd";
import { connect } from "react-redux";
import { CloseCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import CancelarNotaDeCreditoCompra from "./CancelarNotaDeCreditoCompra/CancelarNotaDeCreditoCompra";
class NotasDeCreditoCompra extends Component {
    tableRef = null;
    state = {
        todasNotasDeCredito: [],
        loading: false,
        totalRecords: 0,
        valor: 0,
        modalCorreo: false,
        modalCorreoId: null,
        modalCancelarNotaDeCreditoCompra: false,
        modalCancelarNotaDeCreditoCompraId: null,

    }

    consultarNotasDeCreditoCompra = (params) => {
        this.setState({ loading: true });

        axios
            .post(
                "notasDeCreditoCompra/selectNotasCompra",
                { empresaId: this.props.empresaId, ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasNotasDeCredito:
                            res.data.data.map(value => {
                                return {
                                    ...value,
                                    fechaNota: value.fechaNota ? value.fechaNota : value.createdAt,
                                    accion: { _id: value._id, estado: value.estado, notaId: value._id }
                                }
                            }),
                        totalRecords: res.data.totalRecords || 0,
                        loading: false
                    });
                } else {
                    this.setState({ todasNotasDeCredito: [], loading: false, totalRecords: 0 });
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                message.error("Error al consultar las notas credito");
                console.log(err);
            });
    }


    enviarNota(value) {
        this.setState({ modalCorreo: true, modalCorreoId: value });
    }
    cerrarMandarCorreoNotaDeCreditoCompra() {
        this.setState({
            modalCorreo: false,
            modalCorreoId: null,
        });
    }
    cerrarCancelarNotaDeCreditoCompra() {
        this.setState({
            modalCancelarNotaDeCreditoCompra: false,
            modalCancelarNotaDeCreditoCompraId: null,
        });
        this.consultarNotasDeCreditoCompra()
    }
    agregarNotaDeCreditoCompra() {
        this.props.history.push("/panel/agregarNotaDeCredito");
    }
    importarNotasDeCreditoXml() {
        this.props.history.push("/panel/importarNotasDeCreditoXml");
    }
    render() {
        const columns = [
            {
                title: "Código",
                dataIndex: "codigoFactura",
                key: "codigoFactura",
                buscar: 'codigoFactura',
                width: 100,
            },
            {
                title: "Proveedor",
                dataIndex: "proveedor",
                key: "proveedor",
                width: 250,
                buscar: 'proveedor',
                ellipsis: true,
            },
            {
                title: "Fecha",
                dataIndex: "fechaNota",
                key: "fechaNota",
                defaultSortOrder: 'descend',
                sorter: true,
                render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
                width: 100,
                ellipsis: true,
                align: "center",
            },
            {
                title: 'Subtotal / Total',
                dataIndex: 'subtotal',
                key: 'subtotal',
                sorter: (a, b) => {
                    if (a.subtotal < b.subtotal) {
                        return -1;
                    }
                    if (a.subtotal > b.subtotal) {
                        return 1;
                    }
                    return 0;
                },
                render: (_, record) => (
                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: "12px", color: "#666", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                            <span>{dineroDisabledMask(record.subtotal)}</span>
                            {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                        </div>
                        <div style={{ fontSize: "12px", fontWeight: "bold", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "4px" }}>
                            <span>{dineroDisabledMask(record.totalPagar)}</span>
                            {record.moneda && <span style={{ fontSize: "12px", color: "#666" }}>{record.moneda}</span>}
                        </div>
                    </div>
                ),
                buscar: 'subtotal',
                width: '13%',
                ellipsis: true,
                align: "right",
            },
            {
                title: "Saldo Pendiente",
                dataIndex: "saldoPendiente",
                key: "saldoPendiente",
                render: (value, record) => {
                    if (record.estado === 0) return ""
                    return (
                        <div style={{ textAlign: "right", fontWeight: "bold" }}>
                            {dineroDisabledMask(record.totalPagar - record.totalPagado)} {record.moneda}
                        </div>
                    );
                },
                width: "12%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                responsive: ["md"],
                render: (value, record) => {
                    if (value === 0) {
                        return <Tag color="red" className="square-tag">Cancelada</Tag>;
                    }
                    if (value === 1) {
                        return <Tag color="green" className="square-tag">Vigente</Tag>;
                    }

                },
                width: "13%",
                ellipsis: true,
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: window.innerWidth > 1200 ? "right" : null,
                width: window.innerWidth > 1200 ? 200 : 100,
                align: "center",
                render: (value, index) => {
                    if (value.estado === 0) return null;
                    let buttons = [];

                    buttons.push(
                        <Tooltip title="Cancelar esta nota de crédito" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                            <ButtonItem
                                type="default"
                                size="small"
                                rojo
                                icon={<CloseCircleOutlined />}
                                onClick={() => {
                                    this.setState({ modalCancelarNotaDeCreditoCompra: true, modalCancelarNotaDeCreditoCompraId: value._id })
                                }}
                            />
                        </Tooltip>
                    );

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];
        return (
            <>
                <PageHeader
                    title="Notas de Crédito Compra"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[{ label: 'Todos', value: 0 }, { label: 'Vigentes', value: 1 }, { label: 'Canceladas', value: 2 }]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value });
                                        }
                                        this.setState({ valor: value });
                                    }}

                                    value={this.state.valor}
                                />
                            }
                            <ButtonItem
                                key="importarNotasDeCreditoXml"
                                bondi
                                onClick={this.importarNotasDeCreditoXml.bind(this)}
                                style={{ marginRight: 8 }}
                            >
                                Importar Notas de Crédito XML
                            </ButtonItem>
                            <ButtonItem
                                type="primary"
                                key="agregarNotaDeCreditoCompra"
                                olivo
                                onClick={this.agregarNotaDeCreditoCompra.bind(this)}
                                className="botonAgregar"
                            >
                                Agregar Nota de Crédito Compra
                            </ButtonItem>
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.props.history.push("/panel/verNotaDeCreditoCompra", { id: record._id });
                            },
                        };
                    }}
                    anadirValorFiltro={this.state.valor}
                    onFetchData={this.consultarNotasDeCreditoCompra.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todasNotasDeCredito}
                    columns={columns}
                    filterStorageKey={"notasDeCreditoFiltrosTabla" + this.props.empresaId}
                    pagination={false}
                    setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={0}
                />
                <CancelarNotaDeCreditoCompra
                    visible={this.state.modalCancelarNotaDeCreditoCompra}
                    id={this.state.modalCancelarNotaDeCreditoCompraId}
                    cerrarCancelarNotaDeCreditoCompra={this.cerrarCancelarNotaDeCreditoCompra.bind(this)}
                />

            </>
        );



    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturaGlobal:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
            )?.activado,
    };
};

export default connect(mapStateToProps)(NotasDeCreditoCompra);